import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormTextarea from '../../components/form/FormTextarea/FormTextarea';

const FormTextareaContainer = props =>
  <Field
    name={props.name}
    component={FormTextarea}
    props={props}
  />
;

FormTextareaContainer.propTypes = {
  name: PropTypes.string
};

export default FormTextareaContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/FormTextareaContainer.js
 **/